import React from 'react';
import Select from 'react-select';
//import 'react-select/scss/default.scss';
import 'react-select/dist/react-select.css';

import pick_list from '../data/pick_list3';

const round_pick_re = /^([0-9]+)\.([0-9]+)$/;
const pick_re = /^([0-9]+)$/;

const PickSelect = React.createClass({
	getInitialState () {
		return {
			value: [],
		};
	},
  isRightFormat(pick) {
    return (round_pick_re.test(pick.value) | pick_re.test(pick.value))
  },
	handleSelectChange (value) {
    value = value.filter(this.isRightFormat);
    this.setState({ value });
    this.props.how(value);
	},
  filterOptions: (options, filter, values) => {
    // Filter already selected values
    let filteredOptions = options.filter(option => {
      return !(values.includes(option));
    });

    // Filter by label
    if (filter !== undefined && filter != null && filter.length > 0) {
      filteredOptions = filteredOptions.filter(option => {
        return RegExp(filter, 'ig').test(option.label);
      });
    }

    // Append Addition option
    if (filteredOptions.length === 0 && filter.length > 0) {
      filteredOptions.push({
        label:  <span>{filter}</span>,
        value:  filter,
        create: true,
      });
    }

    return filteredOptions;
  },
	render () {
		return (
			<div className="section">
        <Select multi simplevalue
          value={this.state.value} placeholder={this.props.placeholder}
          allowCreate={true} onChange={this.handleSelectChange} resetValue={[]}
          filterOptions={this.filterOptions} />
			</div>
		);
	}
});

export default PickSelect;




// WEBPACK FOOTER //
// ./src/components/PickSelect.js